import { defineComponent as _defineComponent } from 'vue'
import { encryptionQiutxNews } from "@/api/php/home";
import { ref, onMounted } from "vue";
import Loading from "@/components/Loading.vue";
import { useRouter } from "vue-router";
import { YMPush, formatNewsTime } from "@/uitls/uitls";
import { nativeToNewWeb } from "@/uitls/native";


const __default__ = {
  name: "Newsletter",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  query: {
    topic: Object,
    default: () => ({}),
  },
  pageEvent: {
    type: String,
    default: "HomeNews",
  },
},
  setup(__props, { expose }) {
  expose();

const props = __props



const router = useRouter();

let data = ref([]);
const createQueryParams = () => ({
  pageNum: 1,
  pageSize: 20,
  client_channel: "bro-news",
  ...(props.query || {}),
});
let getnew = ref(createQueryParams());
let loading = ref(true);
let loadingsta = ref(false);
let newsList = ref([]);
let isLoading = ref(false);
let finished = ref(false);
let getlosin = ref(false);

onMounted(() => {
  getData();
  YMPush("MAIN", props.pageEvent)
});

const getData = async () => {
  isLoading.value = true;
  const res: any = await encryptionQiutxNews(getnew.value);
  if (res.code == 200) {
    
    data.value = res.data;
    if (getlosin.value) {
      // 下拉刷新时清空原来数据
      newsList.value = [];
    }
    let list = res.data.list;
    for (let i = 0; i < list.length; i++) {
      let item = list[i];
      // let _time = item.createdDate;
      newsList.value.push(item);
    }
    // 上拉状态
    isLoading.value = false;
    // 下拉状态
    getlosin.value = false;
    // 加载动画
    loading.value = false;
    // 获取数据等于空时
    if (data.value.length == 0) {
      finished.value = true;
    } else {
      finished.value = false;
    }
  }
  loadingsta.value = false;
};
// 上拉加载
const onLoad = () => {
  if (!isLoading.value) {
    getnew.value.pageNum += 1;
    getData();
  }
};
// 跳转详情页
const newslist = (item) => {
  window.$apiNet.statisticsPost({ action_id: 27 }); // 点击快讯统计
  nativeToNewWeb(router, `/NewsDetail?id=${item.id}`)
  // router.push(`/NewsDetail?id=${item.id}`);
};
// 下拉刷新
const onRefresh = () => {
  getnew.value = {
    ...createQueryParams(),
    pageNum: 1,
  };
  getlosin.value = true;
  getData();
};

const __returned__ = { props, router, data, createQueryParams, getnew, loading, loadingsta, newsList, isLoading, finished, getlosin, getData, onLoad, newslist, onRefresh, Loading, formatNewsTime }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})